<template>
  <div id="app">
    <el-row class="el-row-topo nao_imprimir">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/orcamentos/' }">Orçamentos</el-breadcrumb-item>
          <el-breadcrumb-item>Gerar Proposta</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>    
    <el-row style="margin-top:30px;" class="nao_imprimir">
      <el-col :span="20">
        <el-steps :active="active" finish-status="success">
          <el-step title="Proposta Comercial"></el-step>
          <el-step title="Apresentação da Empresa"></el-step>
          <el-step title="Conteúdo da Proposta"></el-step>
          <el-step title="Visualizar Proposta Pronta"></el-step>
          <el-step title="Finalizar"></el-step>
        </el-steps>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <Passo0 v-on:button-click="onButtonClick" :proposta_id=proposta_id v-if="active==0"></Passo0>
        <Passo1 v-on:button-click="onButtonClick" :proposta_id=proposta_id v-else-if="active===1"></Passo1>
        <Passo2 v-on:button-click="onButtonClick" :proposta_id=proposta_id v-else-if="active===2"></Passo2>
        <Passo3 v-on:button-click="onButtonClick" :proposta_id=proposta_id v-else-if="active===3"></Passo3>
        <Passo4 v-on:button-click="onButtonClick" :proposta_id=proposta_id v-else-if="active===4"></Passo4>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Passo0 from "@/components/orcamentos/proposta/Passo0.vue";
import Passo1 from "@/components/orcamentos/proposta/Passo1.vue";
import Passo2 from "@/components/orcamentos/proposta/Passo2.vue";
import Passo3 from "@/components/orcamentos/proposta/Passo3.vue";
import Passo4 from "@/components/orcamentos/proposta/Passo4.vue";

export default {
  components: {
    Passo0,
    Passo1,
    Passo2,
    Passo3,
    Passo4,
  },
  data() {
    return {
      active: 0,
      proposta_id: 0
    };
  },
  methods: {
    onButtonClick: function (e) {
      //alert(e.proposta);
      this.proposta_id = e.proposta;
      this.active = e.active;
    },
  },
};
</script>
<style>
@media print {
  .nao_imprimir{
    display: none;
  }
  .imprimir{
    display: block;
  }  
}
</style>